import _sfc_main from "./DatepickerH5.vue2.mjs";
import "./DatepickerH5.vue3.mjs";
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", [_c(_setup.TuiSelect, { attrs: { "value": _setup.currentValue }, on: { "input": function($event) {
    _setup.currentValue = $event;
  } } }, _vm._l(_setup.yearDates, function(item) {
    return _c(_setup.TuiOption, { key: item.value, attrs: { "value": item.value, "label": item.label } });
  }), 1)], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "7d2bdc0c"
);
const DatepickerH5 = __component__.exports;
export {
  DatepickerH5 as default
};
